"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Messages for issues which can be encountered processing client requests.
 */
class ClientMessages {
    static invalidMetricValue(badType) {
        return ('The track function was called with a non-numeric "metricValue"' +
            ` (${badType}), only numeric metric values are supported.`);
    }
}
ClientMessages.missingContextKeyNoEvent = 'Context was unspecified or had no key; event will not be sent';
exports.default = ClientMessages;
//# sourceMappingURL=ClientMessages.js.map